import React, { useEffect, useContext } from 'react'
import { formatNumbers } from '../Functions/formatNumbers'
import { Totals } from './Totals'
import moment from 'moment'
import Moment from 'react-moment';
import { EditButton } from '../Atoms/Button'
import Edit from '../../Images/icon-edit.svg'
import { getMarge } from '../Functions/getMarge';

import { ProductContext } from '../Context/Context'

const Summary = (props) => {

	const {
		settings,	
		bestellung,
		setBestellung,
		region,
		step,
		setStep,
		generalPrices
} = useContext(ProductContext)



	useEffect(() => {
		getMarge(region, settings, bestellung, setBestellung)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [bestellung.liefermenge, bestellung.lieferstellen])

	const currentDateTime = moment(bestellung.wunschtermin.datum)


	return (
		<div className="no__summary">
			<div className="no__summary-title">
				<h3>Ihre Zusammenfassung</h3>
			</div>
			<div className="no__summary-content">
				{ step === 4 && <><EditButton click={() => setStep(prev => 1)}><img src={Edit} alt="Bearbeiten"/><span>Bearbeiten</span></EditButton><br/></>}
				
				{bestellung.totals.productName !== "" && <div>
					<p><strong>{bestellung.totals.productName}</strong></p>
					<p>Preis pro 100l: <span>{formatNumbers((bestellung.totals.per100Netto + bestellung.totals.productExtra ) * 1.19)} €</span></p>
					{bestellung.totals.aktion && <p className='no__red'>Aktion: <span>-{bestellung.totals.aktion} € / 100 Liter</span></p>}
				</div>}

				{bestellung.liefermenge > 0 && bestellung.plz !== '' &&
					<div>
						<p><strong>Liefermenge gesamt</strong></p>
						<p>{formatNumbers(bestellung.totals.totalAmount)  + ' Liter' || ''}</p>
					</div>}
				
				{bestellung.plz && bestellung.liefermenge > 0 &&
					<div>
						<p><strong>Schlauchlänge</strong></p>
						<p>{bestellung.schlauch ? bestellung.schlauch[0] : ''} {bestellung.totals.schlauch > 0 && <span>{formatNumbers((bestellung.totals.schlauch * 1.19).toFixed(2))} €</span>}</p>
					</div>}
				
				{bestellung.plz && bestellung.liefermenge > 0 && bestellung.lieferfahrzeug.length > 0 &&
					<div>
						<p><strong>Lieferfahrzeug</strong></p>
						<p>{bestellung.lieferfahrzeug[0].split('(')[0]} {parseFloat(bestellung.totals.lieferfahrzeug) > 0 && <span>{parseFloat(bestellung.totals.lieferfahrzeug * 1.19).toFixed(2)} €</span>}</p>
					</div>}
				
				{Object.values(bestellung.lieferstellen).length > 0 &&
					<div>
						<p><strong>Zusätzliche Lieferstellen</strong></p>
						<p>{Object.values(bestellung.lieferstellen).length} Lieferstelle{Object.values(bestellung.lieferstellen).length > 1 ? 'n' : ''} <span>{formatNumbers((Object.values(bestellung.lieferstellen).length * parseFloat(generalPrices.lieferstelle * 1.19)).toFixed(2))} €</span></p>
					</div>}
				
				{bestellung.wunschtermin.datum &&
					<div>
						<p><strong>Wunschtermin</strong></p>
						<p>
							<Moment format='DD.MM.YYYY'>{currentDateTime}</Moment>
						<span>{formatNumbers((bestellung.wunschtermin.value * 1.19).toFixed(2))} €</span></p>
						
						{bestellung.wunschtermin.express > 0 &&
							<p>Expresslieferung <span>{formatNumbers((bestellung.wunschtermin.express * 1.19).toFixed(2))} €</span></p>
						}
					</div>
				}

				{bestellung.wunschtermin.uhrzeit &&
					<div>
						<p><strong>Lieferzeit</strong></p>
						<p>{bestellung.wunschtermin.uhrzeit[0]}<span>{formatNumbers((bestellung.wunschtermin.uhrzeit[1] * 1.19).toFixed(2))} €</span></p>
						
						
					</div>
				}
				{parseInt(bestellung.totals.ggvs) > 0 &&
					<div>
						<p><strong>GGVS</strong></p>
						<p>Gefahrgutzuschlag<span>{formatNumbers( ((Object.values(bestellung.lieferstellen).length + 1) * bestellung.totals.ggvs * 1.19).toFixed(2) )} €</span></p>
						
						
					</div>
				}
				{bestellung.totals.allTotalNetto > 0 &&
					<Totals
						bestellung={bestellung}
						generalPrices={generalPrices}
						aktion={bestellung.totals.aktion}
					/>}
			</div>
		</div>
	)
}

export default Summary
